import type { InterpolationParameters } from "@ngx-translate/core";

export enum NotificationType {
    Success = "success",
    Error = "error",
    Warning = "warning",
    Info = "info",
}

export interface NotificationContent {
    readonly text: string; // Direct text or translation key to text
    readonly textParams?: InterpolationParameters; // Translation interpolation parameters for the text
    readonly isHtml?: boolean;
    readonly url?: string; // Direct URL or translation key to URL
}

export interface NotificationDefinition {
    readonly type: NotificationType;
    /** @deprecated Notification type is resolved in the notificationcatalog. Safe to remove this legacy layout. */
    readonly typeLayout?: string | null;
    readonly heading?: string;
    readonly headingParams?: InterpolationParameters;
    readonly content: NotificationContent | NotificationContent[];
    readonly autoCloseTimeoutMs?: number | null;
}

export interface NotificationRequest {
    readonly messageCode?: string | null;
    readonly context?: NotificationContext;
    /** @deprecated Notification type is resolved in the notification catalog. Safe to remove this legacy layout. */
    readonly typeLayout?: string | null;
    /** @deprecated Pass runtime data through context property. */
    readonly additionInfo?: string | number | null;
    /** @deprecated Titles are resolved by the notification catalog. */
    readonly title?: string | null;
}

export interface NotificationModel extends NotificationDefinition {
    readonly id: number;
    readonly isOpen: boolean;
    readonly autoCloseTimeoutMs: number | null;
}

// Context for generating notification popups which require dynamic content based on runtime information
export type NotificationContext = Readonly<Record<string, unknown>>;
// Factory function type for creating notification popup definitions based on a given context.
// Simple static notifications can use a factory that ignores the context.
export type NotificationDefinitionFactory = (context: NotificationContext) => NotificationDefinition;
